import { useQuery } from '@tanstack/react-query';
import { IKeepInTouchJobConfiguration } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

export const KEEP_IN_TOUCH_CONFIGURATIONS_QUERY_KEY = 'keepInTouchJobConfiguration';

export function useKeepInTouchConfigurations({ enabled = true }: { enabled?: boolean } = {}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<IKeepInTouchJobConfiguration[]>(
				'KeepInTouchJobConfiguration',
				'GET'
			);
		},
		queryKey: [KEEP_IN_TOUCH_CONFIGURATIONS_QUERY_KEY],
		meta: {
			toastErrorMessage: 'Failed to load Keep In Touch configurations',
		},
	});
}

export const invalidateKeepInTouchConfigurations = () => {
	reactQueryClient.invalidateQueries({ queryKey: [KEEP_IN_TOUCH_CONFIGURATIONS_QUERY_KEY] });
};
